import { render, staticRenderFns } from "./vFormEditor.vue?vue&type=template&id=abbf665a&scoped=true&"
import script from "./vFormEditor.vue?vue&type=script&lang=js&"
export * from "./vFormEditor.vue?vue&type=script&lang=js&"
import style1 from "./vFormEditor.vue?vue&type=style&index=1&id=abbf665a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbf665a",
  null
  
)

export default component.exports